module.exports = __webpack_public_path__ + "static/img/zusu.b1c0251d.png";